import { render, staticRenderFns } from "./PaymentMethodsCardSelector.vue?vue&type=template&id=348b6796&scoped=true&"
import script from "./PaymentMethodsCardSelector.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsCardSelector.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodsCardSelector.vue?vue&type=style&index=0&id=348b6796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348b6796",
  null
  
)

/* custom blocks */
import block0 from "./PaymentMethodsCardSelector.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./PaymentMethodsCardSelector.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VIcon,VMenu,VRadio,VRadioGroup,VTooltip})
